import vuetify, {defaultLanguage} from "../../plugins/vuetify";
import store from '@/store';

/*
loadStoredClientProjectSettings(state){
          let storedClientProjectSettings = {}

          if (localStorage.getItem(storageKey_CPS)) {
            try {
              storedClientProjectSettings = JSON.parse(localStorage.getItem(storageKey_CPS));
              if(storedClientProjectSettings[state.user_id] !== undefined){
                Object.assign(state.currentClientProjectSettings, storedClientProjectSettings[state.user_id]);
              }else{
                state.currentClientProjectSettings = new clientProjectSettings('', '', '', '');
              }
            } catch (e) {
              localStorage.removeItem(storageKey_CPS);
            }
          }
        },
        setClientProjectSettings(state, payload) {
            if (payload instanceof clientProjectSettings) {
                console.log('all good...')

                console.log('mutating');
                console.log(payload);
                Object.assign(state.currentClientProjectSettings, payload);

                let storedClientProjectSettings = {}

                if (localStorage.getItem(storageKey_CPS)) {
                    try {
                        storedClientProjectSettings = JSON.parse(localStorage.getItem(storageKey_CPS))
                    } catch (e) {
                        localStorage.removeItem(storageKey_CPS);
                    }
                }
                storedClientProjectSettings[state.user_id] = payload;
                localStorage.setItem(storageKey_CPS, JSON.stringify(storedClientProjectSettings));
            }
        },
* */

export const pref_lang_skey = 'STORED_PREF_LANG';

export const UserLanguageHelper = {
    getUserPreferredLanguage(){
        let stored_lang = this.loadStoredPrefLanguage()
        if(this.loadStoredPrefLanguage()){
            return stored_lang
        }else{
            return this.get_checked_user_language_from_browser();
        }
    },
    loadStoredPrefLanguage(){
        return localStorage.getItem(pref_lang_skey);
    },
    get_checked_user_language_from_browser() {
        let browserLanguage = navigator.language.slice(0, 2);
        if (vuetify.framework.lang.locales[browserLanguage] !== undefined) {
            return browserLanguage;
        } else {
            return defaultLanguage
        }
    },
    async setAndSaveUserLanguage(language){
        await store.dispatch('setUserLanguage', language);
        vuetify.framework.lang.current = language
        localStorage.setItem(pref_lang_skey, language);
    }
}